import React from "react";
import { Tabs } from "antd";
import AttendanceDailyTable from "./AttendanceDailyTable";
import AttendanceMonthlyReport from "./AttendanceMonthlyReport";

interface Props {
  programId: number;
  programStatus?: "active" | "inactive";
}

export default function TabProgramAttendance({
  programId,
  programStatus = "active",
}: Props) {
  const programActive = programStatus === "active";

  return (
    <Tabs
      defaultActiveKey="daily"
      items={[
        {
          key: "daily",
          label: "Registro diario",
          children: (
            <AttendanceDailyTable
              programId={programId}
              programActive={programActive}
            />
          ),
        },
        {
          key: "report",
          label: "Reporte mensual",
          children: <AttendanceMonthlyReport programId={programId} />,
        },
      ]}
    />
  );
}
